import {
  GET_SIM_INVENTORY,
  GET_SIM_DISTRIBUTION,
  GET_ADMIN_USER_1,
  MANAGE_SIM_INVENTORY,
  GET_USER_TYPES,
  GET_SIM_USER_DISTRIBUTION,
  GET_USER_SIM_STOCK,
  SAVE_INVOICE_SIM,
  CHECK_SIM_INVOICE,
  GET_SIM_SEARCH,
  GET_SIM_ICCID,
  GET_SELLING_PRICE,
  MANAGE_BULK_SIM_INVENTORY,
  GET_SIM_COUNT,
  GET_MULTISELLING_PRICE,
  MANAGE_BULK_MULTI_SIM_INVENTORY,
  CHECK_MULTI_SIM_INVOICE
} from "../../admin-constants";

const initialState = {
  adminuser: [],
  simDistributionData: [],
  simInventoryData: [],
  simStockData: [],
  userSimStockData: [],
  userTypeList: [],
  iccidData: [],
  changeStatus: {},
  manageSimStockData: {},
  storeXmlData: {},
  simUserDistributionData: [],
  msisdnData: [],
  availablePhoneNumber: [],
  msisdnListData: [],
  msisdnUploadList: [],
  msisdnSearchListData: [],
  simTrackingData: [],
  simInvoiceData: {},
  simInvoiceCheckStatus: {},
  simSearchData: [],
  sellingPriceData: [],
  manageBulkSimInventoryData: {},
  simCountData: {},
  multiSellingPriceData:[],
   manageMultiBulkSimInventoryData:[]
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SIM_INVENTORY: {
      return {
        ...state,
        simInventoryData: payload,
      };
    }

    case GET_SIM_DISTRIBUTION: {
      return {
        ...state,
        simDistributionData: payload,
      };
    }

    case GET_ADMIN_USER_1: {
      return {
        ...state,
        adminuser: payload,
      };
    }

    // case GET_SIM_STOCK: {
    //   return {
    //     ...state,
    //     simStockData: payload,
    //   };
    // }

    case GET_SIM_USER_DISTRIBUTION: {
      return {
        ...state,
        simUserDistributionData: payload,
      };
    }

    case GET_USER_SIM_STOCK: {
      return {
        ...state,
        userSimStockData: payload,
      };
    }

    case MANAGE_SIM_INVENTORY: {
      return {
        ...state,
        simInventoryData: [payload, ...state.simInventoryData],
      };
    }

    case GET_USER_TYPES: {
      return {
        ...state,
        userTypeList: payload,
      };
    }

    case SAVE_INVOICE_SIM: {
      return {
        ...state,
        simInvoiceData: payload,
      };
    }

    case CHECK_SIM_INVOICE: {
      return {
        ...state,
        simInvoiceCheckStatus: payload,
      };
    }

    case GET_SIM_SEARCH: {
      return {
        ...state,
        simSearchData: payload,
      };
    }

    case GET_SIM_ICCID: {
      return {
        ...state,
        iccidData: payload,
      };
    }

    case GET_SELLING_PRICE: {
      return {
        ...state,
        sellingPriceData: payload,
      };
    }

    case MANAGE_BULK_SIM_INVENTORY: {
      return {
        ...state,
        manageBulkSimInventoryData: payload,
      };
    }
   case GET_SIM_COUNT: {
      return {
        ...state,
        simCountData: payload,
      };
    }
 case GET_MULTISELLING_PRICE: {
      return {
        ...state,
        multiSellingPriceData: payload,
      };
    }
    case MANAGE_BULK_MULTI_SIM_INVENTORY: {
      return {
        ...state,
        manageMultiBulkSimInventoryData: payload,
      };
    }
    case CHECK_MULTI_SIM_INVOICE: {
      return {
        ...state,
        simInvoiceCheckStatus: payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
